import { z } from "zod";

export const LoginFormSchema = z
  .object({
    loginType: z.enum(["email", "phone"]),
    email: z.string().optional(),
    phone: z.string().optional(),
    password: z.string().min(1, { message: "Senha inválida" }),
  })
  .superRefine((data, ctx) => {
    if (data.loginType === "email") {
      if (!data.email) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: "Email obrigatório",
          path: ["email"],
        });
      } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data.email)) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: "Email inválido",
          path: ["email"],
        });
      }
    }

    if (data.loginType === "phone") {
      if (!data.phone) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: "WhatsApp obrigatório",
          path: ["phone"],
        });
      } else if (!/^55\d{11}$/.test(data.phone)) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: "WhatsApp inválido",
          path: ["phone"],
        });
      }
    }
  });
